import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Edit, Trash2 } from 'lucide-react';

interface RuleCardProps {
  rule: {
    id: string;
    ruleLabel: string;
    ruleType: 'ALLOW' | 'DENY';
    canonicalTagLabel: string;
    canonicalTagDescription?: string | null;
  };
  onEdit: (ruleId: string) => void;
  onDelete: (ruleId: string) => void;
}

export function RuleCard({ rule, onEdit, onDelete }: RuleCardProps) {
  return (
    <Card className="hover:shadow-sm transition-shadow">
      <CardContent className="p-4">
        <div className="flex items-start justify-between gap-3">
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 mb-2">
              <Badge variant={rule.ruleType === 'ALLOW' ? 'default' : 'destructive'}>
                {rule.ruleType}
              </Badge>
              <span className="text-sm font-medium truncate">{rule.ruleLabel}</span>
            </div>
            <div className="space-y-1">
              <p className="text-sm font-medium text-gray-900">{rule.canonicalTagLabel}</p>
              {rule.canonicalTagDescription && (
                <p className="text-xs text-gray-500 line-clamp-2">{rule.canonicalTagDescription}</p>
              )}
            </div>
          </div>
          <div className="flex items-center gap-1 shrink-0">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => onEdit(rule.id)}
              className="h-8 w-8 p-0"
            >
              <Edit className="h-4 w-4" />
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => onDelete(rule.id)}
              className="h-8 w-8 p-0 text-red-600 hover:text-red-700 hover:bg-red-50"
            >
              <Trash2 className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
